import { render, staticRenderFns } from "./citedPushTemplateConfig.vue?vue&type=template&id=b6a56802&scoped=true"
import script from "./citedPushTemplateConfig.vue?vue&type=script&lang=js"
export * from "./citedPushTemplateConfig.vue?vue&type=script&lang=js"
import style0 from "./citedPushTemplateConfig.vue?vue&type=style&index=0&id=b6a56802&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6a56802",
  null
  
)

export default component.exports